import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

const selectAppState = (state: RootState) => state.app;

export const selectActiveRubrics = createSelector(
    [selectAppState],
    (app) => app.activeRubrics,
);

export const selectSelectedAssociates = createSelector(
    [selectAppState],
    (app) => app.selectedAssociates,
);

export const selectSettings = createSelector(
    [selectAppState],
    (app) => app.settings,
);

export const selectCurrentUserComponent = createSelector(
    [selectAppState],
    (app) => app.rubric.currentUserComponent,
);

export const selectAddingNewRubric = createSelector(
    [selectAppState],
    (app) => app.addingNewRubric,
);

export const selectShowCreateCalibrationForm = createSelector(
    [selectAppState],
    (app) => app.calibration.showCreateCalibrationForm,
);

export const selectShowOnboardingForAdminsThatHasnotCreatedCalibrations =
    createSelector(
        [selectAppState],
        (app) =>
            app.calibration.showOboardingForAdminsThatHasnotCreatedCalibrations,
    );

export const selectCalibrationStep = createSelector(
    [selectAppState],
    (app) => app.calibration.step,
);

export const selectCalibrationId = createSelector(
    [selectAppState],
    (app) => app.calibration.calibrationId,
);

export const selectShowModalAfterCreating = createSelector(
    [selectAppState],
    (app) => app.calibration.showModalAfterCreating,
);

export const selectShowSideDrawer = createSelector(
    [selectAppState],
    (app) => app.showSideDrawer,
);
